import {
  GET_BASIC_PROVIDER_INFORMATION,
  GET_BASIC_PROVIDER_INFORMATION_FAILURE,
  GET_BASIC_PROVIDER_INFORMATION_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getBasicProviderInforrmationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BASIC_PROVIDER_INFORMATION:
      return { ...state, loading: true };
    case GET_BASIC_PROVIDER_INFORMATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_BASIC_PROVIDER_INFORMATION_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getBasicProviderInforrmationReducer;
